(function () {
  function initMediaSlider(sliderEl) {
    if (sliderEl.dataset.sliderInitialized === 'true') return;
    sliderEl.dataset.sliderInitialized = 'true';

    const track = sliderEl.querySelector('[data-slider-track]');
    const slides = Array.from(sliderEl.querySelectorAll('[data-slide]'));
    if (!track || !slides.length) return;

    const prevBtn = sliderEl.querySelector('[data-slider-prev]');
    const nextBtn = sliderEl.querySelector('[data-slider-next]');
    const dotsContainer = sliderEl.querySelector('[data-slider-dots]');
    const dots = [];
    let currentIndex = 0;

    function goTo(index, instant) {
      currentIndex = (index + slides.length) % slides.length;

      if (instant) {
        const previousTransition = track.style.transition;
        track.style.transition = 'none';
        track.style.transform = `translateX(-${currentIndex * 100}%)`;
        void track.offsetWidth;
        track.style.transition = previousTransition;
      } else {
        track.style.transform = `translateX(-${currentIndex * 100}%)`;
      }

      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === currentIndex);
        dot.setAttribute('aria-current', dotIndex === currentIndex ? 'true' : 'false');
      });
    }

    if (slides.length > 1) {
      if (dotsContainer) {
        slides.forEach((slide, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'melalight-in-the-box__slider-dot';
          dot.setAttribute('aria-label', `Go to image ${index + 1} of ${slides.length}`);
          dot.addEventListener('click', () => goTo(index));
          dotsContainer.appendChild(dot);
          dots.push(dot);
        });
      }

      prevBtn?.addEventListener('click', () => goTo(currentIndex - 1));
      nextBtn?.addEventListener('click', () => goTo(currentIndex + 1));

      sliderEl.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(currentIndex - 1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(currentIndex + 1);
        }
      });

      let touchStartX = null;
      sliderEl.addEventListener(
        'touchstart',
        (event) => {
          touchStartX = event.changedTouches[0].clientX;
        },
        { passive: true }
      );
      sliderEl.addEventListener(
        'touchend',
        (event) => {
          if (touchStartX === null) return;
          const deltaX = event.changedTouches[0].clientX - touchStartX;
          touchStartX = null;
          if (Math.abs(deltaX) < 40) return;
          goTo(deltaX < 0 ? currentIndex + 1 : currentIndex - 1);
        },
        { passive: true }
      );
    }

    goTo(0, true);
  }

  function initSections() {
    document
      .querySelectorAll('.melalight-in-the-box [data-media-slider]')
      .forEach((slider) => initMediaSlider(slider));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSections);
  } else {
    initSections();
  }

  document.addEventListener('shopify:section:load', initSections);
})();
